// extracted by mini-css-extract-plugin
export default {"form-main-container":"BFUserInputForm_form-main-container__SLWkl"};